/** Shopify CDN: Minification failed

Line 16:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 19:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 21:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 22:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 40:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 41:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 42:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 43:2 Transforming const to the configured target environment ("es5") is not supported yet
... and 2 more hidden warnings

**/
const getObjectFitSize = (contains, containerWidth, containerHeight, width, height) => {
  const doRatio = width / height;
  const cRatio = containerWidth / containerHeight;
  const test = contains ? (doRatio > cRatio) : (doRatio < cRatio);

  let targetWidth = 0;
  let targetHeight = 0;

  if (test) {
      targetWidth = containerWidth;
      targetHeight = targetWidth / doRatio;
  } else {
      targetHeight = containerHeight;
      targetWidth = targetHeight * doRatio;
  }

  return {
      width: targetWidth,
      height: targetHeight,
      x: (containerWidth - targetWidth) / 2,
      y: (containerHeight - targetHeight) / 2
  };
}

const correctThumbBounds = (thumbBounds, itemData, index) => {
  const thumbnail = itemData.element.querySelector('img');
  const rect = thumbnail.getBoundingClientRect();
  const rectRatio = getObjectFitSize(true, thumbnail.width, thumbnail.height, thumbnail.naturalWidth, thumbnail.naturalHeight);
  const leftRatioAdjusted = rect.left + (rect.width / 2) - (rectRatio.width / 2);
  const topRatioAdjusted = rect.top + (rect.height / 2) - (rectRatio.height / 2);

  return {
    x: leftRatioAdjusted,
    y: topRatioAdjusted,
    w: rectRatio.width
  };
}

export { correctThumbBounds }
